<template>
  <div :class="[props.wrapperClasses]">
    <a
      :href="props.url"
      class="d-block btn text-decoration-none"
      target="_blank"
      :class="[classes, props.buttonClasses]"
      @click.prevent="toolCtaClicked"
    >
      {{ props.label }}
    </a>
    <small v-if="props.subtext" class="text-muted"> {{ props.subtext }}</small>
  </div>
</template>

<script setup lang="ts">
import { rbgToolsCtaClickedV100 } from "kaleido-event-tracker";
import { computed } from "vue";

export interface ToolCtaProps {
  label: string;
  url: string;
  slug: string;
  buttonType?: string;
  buttonClasses?: string;
  wrapperClasses?: string;
  subtext?: string;
}

const props = withDefaults(defineProps<ToolCtaProps>(), {
  buttonType: "primary",
});

const toolCtaClicked = () => {
  rbgToolsCtaClickedV100({
    tool_slug: props.slug,
  });
  window.open(props.url, "_blank");
};

const classes = computed(() => {
  return {
    "btn-primary": props.buttonType === "primary",
    "btn-outline-primary": props.buttonType !== "primary",
  };
});
</script>
